import { DefaultFormFields, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

export default class CustomReplicatedInfoStore {
  rootStore: RootStore;

  // We might have several custom components with additional form (forms inside form) in one form, but only one instance of the store,
  // so that's why it should be a Record, where component key is a key in it and value - Additional Form from the custom component
  customForms: Record<string, FormController<DefaultFormFields>>;

  setForm(key: string, form: FormController<DefaultFormFields>): void {
    this.customForms[key] = form;
  }

  getForm(key: string): FormController<DefaultFormFields> {
    return this.customForms[key];
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.customForms = {};

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
